import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getAthleteInvitation } from "api-client";
import { assert } from "utils";

import { InvitationsContextProvider } from "src/invitations";
import { loaderHandler } from "src/lib/loaderHandler";

export const Route = createFileRoute("/_public/invitations/$invitationId")({
  component: RoutePage,
  ssr: true,
  async loader({ params }) {
    return await loaderHandler(async () => {
      try {
        assert(params.invitationId, "No invitation ID provided");
        const invitation = await getAthleteInvitation({
          path: { invitationId: params.invitationId },
        }).then((response) => response.data.data);
        return {
          data: {
            invitation,
          },
        };
      } catch {
        throw redirect({
          to: "/",
        });
      }
    });
  },
});

function RoutePage() {
  const loaderData = Route.useLoaderData();
  const invitation = loaderData.data.invitation;

  return (
    <InvitationsContextProvider invitation={invitation}>
      <Outlet />
    </InvitationsContextProvider>
  );
}
